module.exports = __webpack_public_path__ + "img/14.27ec9a10.png";